import { parseInstant } from './dataFormat';
export function relativeTimeLabel(at: string | Date, now: number): string {
  const date = parseInstant(at);
  if (!date || !Number.isFinite(now)) return 'Время неизвестно';
  const delta = date.getTime() - now,
    absolute = Math.abs(delta);
  if (absolute < 45000) return delta > 0 ? 'через несколько секунд' : 'только что';
  const [unit, size]: [Intl.RelativeTimeFormatUnit, number] =
    absolute < 3600000
      ? ['minute', 60000]
      : absolute < 86400000
        ? ['hour', 3600000]
        : absolute < 30 * 86400000
          ? ['day', 86400000]
          : ['month', 30 * 86400000];
  return new Intl.RelativeTimeFormat('ru-RU', { numeric: 'always' }).format(Math.round(delta / size), unit);
}
export function intervalDuration(start: string | Date, end: string | Date): string | undefined {
  const from = parseInstant(start),
    to = parseInstant(end);
  if (!from || !to || to.getTime() <= from.getTime()) return undefined;
  const millis = to.getTime() - from.getTime();
  if (millis < 60000) return 'менее 1 мин';
  let minutes = Math.floor(millis / 60000);
  const days = Math.floor(minutes / 1440);
  minutes %= 1440;
  const hours = Math.floor(minutes / 60);
  minutes %= 60;
  return [
    days ? days + ' д' : undefined,
    hours ? hours + ' ч' : undefined,
    minutes ? minutes + ' мин' : undefined,
  ]
    .filter(Boolean)
    .join(' ');
}
export function zoneOffset(at: Date, timeZone: string): string {
  return new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'shortOffset' })
    .formatToParts(at)
    .find((part) => part.type === 'timeZoneName')!
    .value.replace('GMT', 'UTC');
}
